// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponseEnvironmentMetadata
 */
export interface ResponseEnvironmentMetadata {
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentMetadata
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentMetadata
   */
  deletedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentMetadata
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentMetadata
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseEnvironmentMetadata
   */
  updatedAt?: string;
}

/**
 * Check if a given object implements the ResponseEnvironmentMetadata interface.
 */
export function instanceOfResponseEnvironmentMetadata(
  value: object,
): value is ResponseEnvironmentMetadata {
  return true;
}

export function ResponseEnvironmentMetadataFromJSON(
  json: any,
): ResponseEnvironmentMetadata {
  return ResponseEnvironmentMetadataFromJSONTyped(json, false);
}

export function ResponseEnvironmentMetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseEnvironmentMetadata {
  if (json == null) {
    return json;
  }
  return {
    createdAt: json['created_at'] == null ? undefined : json['created_at'],
    deletedAt: json['deleted_at'] == null ? undefined : json['deleted_at'],
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    updatedAt: json['updated_at'] == null ? undefined : json['updated_at'],
  };
}

export function ResponseEnvironmentMetadataToJSON(
  json: any,
): ResponseEnvironmentMetadata {
  return ResponseEnvironmentMetadataToJSONTyped(json, false);
}

export function ResponseEnvironmentMetadataToJSONTyped(
  value?: ResponseEnvironmentMetadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    created_at: value['createdAt'],
    deleted_at: value['deletedAt'],
    id: value['id'],
    name: value['name'],
    updated_at: value['updatedAt'],
  };
}
